// TODO: Kind of a bootleg solution
function parseTimestamp(rawTimestamp) {
    // If the timestamp already has a timezone or Z suffix, use as-is
    const hasTimezone =
        rawTimestamp.includes('Z') || rawTimestamp.includes('+');
    return new Date(hasTimezone ? rawTimestamp : rawTimestamp + 'Z');
}

function formatTimestamp(rawTimestamp) {
    const msgDate = parseTimestamp(rawTimestamp);
    const now = new Date();

    const diffMs = now - msgDate;
    const diffMin = Math.floor(diffMs / 60000);
    const isToday = msgDate.toDateString() === now.toDateString();

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = msgDate.toDateString() === yesterday.toDateString();

    const sameYear = msgDate.getFullYear() === now.getFullYear();

    if (diffMin < 1) {
        return 'Just now';
    } else if (isToday) {
        // Show time only (HH:MM AM/PM)
        return msgDate.toLocaleTimeString([], {
            hour: 'numeric',
            minute: '2-digit',
        });
    } else if (isYesterday) {
        return 'Yesterday';
    } else if (sameYear) {
        // Show date only (e.g., Apr 27)
        return msgDate.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
        });
    } else {
        // Show full date with year (e.g., Apr 27, 2024)
        return msgDate.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    }
}

export default formatTimestamp;
